import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../app.state';
import { DeductEmotesCountInFireBase, EmotesCollection } from './emotes.state';
import * as EmotesActions from '../emotes/emotes.actions';

@Injectable()
export class EmoteStateDispatcher {
    constructor(private store: Store<AppState>) {}

    public getEmotes() {
        this.store.dispatch(EmotesActions.loadEmotesAction());
    }

    public deductEmotesCount(payload: DeductEmotesCountInFireBase) {
        this.store.dispatch(EmotesActions.deductEmotesCountInFireBase({data: payload}));
    }

    public getEmoteState(): Observable<EmotesCollection> {
        return this.store.select((state: AppState) => state.emotes);
    }
}
